import "@hotwired/turbo-rails"
import "./controllers"
import "tom-select/dist/css/tom-select.css"
import "./styles/tom_select_overrides.css"

// A frame navigation promoted to a visit (live search, A–Z, filters, paging)
// sets Turbo's forceReloaded and never clears it, so every later visit skips
// the scroll to the top and opens partway down.
// TODO(AHPA-267): private Turbo API; delete once hotwired/turbo#1545 ships.
addEventListener("turbo:visit", () => { Turbo.session.view.forceReloaded = false })
